import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import ContratadosPresentes from './ContratadosPresentes';
import PresencaContratado from './PresencaContratado';
//import CalendarioPresenca from '../calendarioPresenca/CalendarioPresenca';
import UltimosRegistros from './UltimosRegistros';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Registro de Acesso" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (containsRole(['admin', 'porteiro', 'zelador'])) {
              children.push(PresencaContratado, ContratadosPresentes);
            }
            if (containsRole(['conselheiro', 'sindico'])) {
              children.push(/*CalendarioPresenca, */UltimosRegistros);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/Index.js